import { Component, OnInit, Input, HostListener } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { EupRoutesService } from '../../core/eupRoutes.service';
import { Regions, Language } from '@shared/enums';
import { BiFeatureWrapperService } from '@logging/bi-feature-wrapper.service';

@Component({
	selector: 'eup-footer',
	templateUrl: './footer.component.html',
	styleUrls: [ './footer.component.scss' ]
})
export class FooterComponent implements OnInit {
	public text: String;
	currentYear = new Date().getFullYear();
	@Input() isParentLogin = 'false';
	@Input() icpPsbVisible = false;
	
	@HostListener('click', ['$event'])
	onClick(event: Event) {
		const targetElement = event.target as HTMLElement;
		this.biFeatureWrapperService.CheckIfLinkClick(targetElement, 'Footer');
	}

	constructor(
		private translateService: TranslateService,
		private eupRoutesService: EupRoutesService,
		private biFeatureWrapperService: BiFeatureWrapperService
	) {
		this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
			this.createHTML();
		});
	}

	ngOnInit(): void {
		this.createHTML();
	}

	createHTML() {
		this.eupRoutesService.getRoutes().subscribe((routingData) => {
			const lang = this.translateService.currentLang;
			const PrivacyNCookiesUrlLang = (this.eupRoutesService.Region === Regions.china) && (this.isParentLogin == 'true') ? Language.ZHCN : this.translateService.currentLang ;

			const alignUrl = this.eupRoutesService.AlignUrl?.split('{0}').join(lang);
			const termsUrl = this.eupRoutesService.TermsUrl?.split('{0}').join(lang);
			const privacyNCookiesUrl = this.eupRoutesService.PrivacyNCookiesUrl?.split('{0}').join(PrivacyNCookiesUrlLang);

			const all = this.translateService.instant('Footer.All', {year: this.currentYear});
			const align = this.translateService.instant('Footer.Align');
			const privacyNCookies = this.translateService.instant('Footer.PrivacyNCookies');
			const terms = this.translateService.instant('Footer.Terms');
			this.text = all
				.replace(align, `<a class="footer-link" href="${alignUrl}" target="_blank">${align}</a>`)
				.replace(terms, `<a class="footer-link" href="${termsUrl}" target="_blank">${terms}</a>`)
				.replace(
					privacyNCookies,
					`<a class="footer-link" href="${privacyNCookiesUrl}" target="_blank">${privacyNCookies}</a>`
				);
		});
	}
}
